import styled from 'styled-components';

import { SafeAreaView } from 'components/safe-area-view';

import { brandSpecificNavBorderStyle } from './mobile-web-navigation-border.styled';

export const MobileWebNavigationBorder = styled(SafeAreaView)`
  display: initial;
  padding-block-start: 0;
  border-block-start: 1px solid ${Styles.color.grey.three};
  width: 100%;
  z-index: ${Styles.zIndex.overlay};
  ${brandSpecificNavBorderStyle}
  ${Styles.desktopLarge} {
    display: none;
  }
`;
